const _dir = $('html').attr('dir');
const _isRtl = (_dir === 'rtl');
(
    ($) => {
        $(document).ready(function () {
                const body = $('body');
                const wrapper = $('#menu-list').clone();
                wrapper.attr('id', 'menu-list-new');
                const mainUl = wrapper.find('.main-menu-list');
                let MenuCreated = true;

                const closeBtn = $('<button class="mobile-close-btn"><i class="icon-close"></i></button>');

                function mobileMenuFun() {
                    if ($(window).width() <= 991) {
                        let _icon = 'icon-arrow-right';
                        let _back_icon = 'icon-arrow-left';

                        if (_isRtl) {
                            _icon = 'icon-arrow-left';
                            _back_icon = 'icon-arrow-right';
                        }

                        if (body.find('.main-menu-list--mobile').length) {
                            return;
                        }
                        body.append(wrapper);

                        if (MenuCreated) {
                            wrapper.prepend(closeBtn);
                            wrapper.addClass('main-menu-list--mobile');

                            mainUl.attr('id', IdGenerator());
                            const menu = wrapper.find('.main-menu-list li');
                            menu.each(function (index, child) {
                                if ($(child).children("ul").length) {
                                    const id = IdGenerator();
                                    $(child).find('> .item').attr('data-target', '#' + id);
                                    const ulChild = $(child).children('ul');
                                    // const ulTitle = $('<li><div class="ul-title"></div></li>');
                                    const back = $(`<li><button class="back"><i class="${_back_icon}"></i><div class="ul-title"></div></button></li>`);
                                    back.find('.ul-title').text($(child).find('> .item').html());
                                    ulChild.prepend(back);
                                    // ulChild.prepend(ulTitle);
                                    $(ulChild).addClass('main-menu-list').attr('id', id);
                                    wrapper.append(ulChild);
                                    $(child).find('> .item').addClass('has-dropdown').append(`<i class="${_icon}"></i>`)
                                }
                            });
                            backAttr();
                            MenuCreated = false;
                        }
                    } else {
                        $('body').find(wrapper).remove();
                    }

                    $(wrapper).find('.item').on('click', function (e) {
                        const _tab = $(this);
                        if (_tab.hasClass('has-dropdown')) {
                            e.preventDefault();
                        }
                        $(wrapper).find('.main-menu-list').removeClass('open');
                        const el = $(_tab.attr('data-target'));
                        el.addClass('open');
                    });

                    $(wrapper).find('.back').on('click', function () {
                        const _tab = $(this);
                        $(wrapper).find('.main-menu-list').removeClass('open');
                        const id = _tab.attr('data-target');
                        const el = $('[id="' + id + '"]');
                        el.addClass('open');
                    });
                }

                function backAttr() {
                    const back = wrapper.find('.back');
                    back.each(function (index, el) {
                        const id = $(el).parents('ul').attr('id');
                        const parentId = $(wrapper).find('[data-target="#' + id + '"]').closest('[id]').attr('id');
                        $(el).attr('data-target', parentId);
                    });
                }

                const mobileBtn = $('.burger');
                mobileBtn.on('click', function () {
                    if (!$(mobileBtn).hasClass('open')) {
                        $(mobileBtn).addClass('open');
                        wrapper.addClass('open');
                        mainUl.addClass('open');
                        $('body').css('overflow', 'hidden');
                    } else {
                        $(mobileBtn).removeClass('open');
                        wrapper.removeClass('open');
                        $('.main-menu-list').removeClass('open');
                        $('body').removeAttr('style');
                    }
                });

                body.on('click', '.mobile-close-btn', function () {
                    $(mobileBtn).removeClass('open');
                    wrapper.removeClass('open');
                    $('.main-menu-list').removeClass('open');
                    $('body').removeAttr('style');
                });

                /**
                 * @return {string}
                 */
                function IdGenerator() {
                    return (((1 + Math.random()) * 0x1000000) | 0).toString(16).substring(1);
                }

                mobileMenuFun();

                $(window).on('resize', function () {
                    mobileMenuFun();
                });

                // mini mobile menu
                if ($(window).width() <= 575) {
                    const miniMobileMenu = $(`<div class="mini-mobile-menu"></div>`);

                    const mobileMenu = application.translations.mobile_menu;

                    $(mobileMenu).each(function (index, item) {
                        const _item = $(item)[0];
                        const _extra_classes = _item.class;
                        let _icon = $(`<i class="${_item.icon}"></i>`);
                        let _title = $(`<div class="title">${_item.title}</div>`);
                        let parent = $(`<div class="mini-mobile-home mini-mobile-item ${_extra_classes}" data-target="#${_item.id}"></div>`);
                        if (_item.url.length > 0) {
                            parent = $(`<a href="${_item.url}" title="${_item.title}" class="mini-mobile-home mini-mobile-item ${_extra_classes}"></a>`);
                        }
                        if (parent.hasClass('main_menu')) {
                            _icon = $('#mobile-button');
                        } else if (parent.hasClass('language')) {
                            _icon = _item.icon;
                        } else if (parent.hasClass('sub_links')) {
                            const items = $('#js-sub-menu-list li a');
                            $(items).each(function (index, item) {
                                const _item = $(item);
                                _icon = _item.attr('data-icon');
                                _title = $(`<div class="title">${_item.html().trim()}</div>`);
                                parent = $(`<a href="${_item.attr('href')}" title="${_item.html().trim()}" class="mini-mobile-home mini-mobile-item ${_extra_classes}"></a>`);

                                const _iconFull = $(`<span class="icon"><i class="${_icon}"></i></span>`);
                                parent.append(_iconFull);
                                parent.append(_title);
                                miniMobileMenu.append(parent);
                            });
                            return;
                        }
                        const _iconFull = $('<span class="icon"></span>').append(_icon);
                        parent.append(_iconFull);
                        parent.append(_title);
                        // parent.append(`<span class="title">${_item.title}</span>`);
                        miniMobileMenu.append(parent);
                        body.append(miniMobileMenu);
                    })

                    miniMobileMenu.children().each(function (index, menu) {
                        const _menu = $(menu);
                        if (_menu.hasClass('has_sub')) {
                            const id = _menu.attr('data-target').replace('#', '');
                            if (_menu.hasClass('sub_links')) {
                                return false;
                                //     const items = $('#js-sub-menu-list').find('>li> a');
                                //     createMenu(id, 'style1', items);
                            } else if (_menu.hasClass('main_menu')) {
                                const items = $('#mobile-menu');
                                createMenu(id, 'style2', items);
                            }
                        }
                    });

                    body.on('click', '.mini-mobile-item', function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        const _clicked = $(this);

                        if (!_clicked.hasClass('open')) {
                            $('.mini-mobile-item.open').removeClass('open');
                            $('.mini-mobile-sub.open').removeClass('open');
                            $('.burger.open').removeClass('open');
                            $('#menu-list-new.open').removeClass('open');
                            $('#menu-list-new').find('.main-menu-list').removeClass('open');
                            _clicked.addClass('open');

                            if (_clicked.hasClass('has_sub')) {
                                const target = $(_clicked.attr('data-target'));
                                target.addClass('open');

                                if (_clicked.hasClass('main_menu')) {
                                    $('#menu-list-new').addClass('open');
                                    $('#menu-list-new .main-menu-list').first().addClass('open');
                                    _clicked.find('.burger').addClass('open');
                                }
                            }
                        } else {
                            _clicked.removeClass('open');
                            $('#menu-list-new').removeClass('open');
                            $('#menu-list-new').find('.main-menu-list').removeClass('open');
                            _clicked.find('.burger').removeClass('open');

                            if (_clicked.hasClass('has_sub')) {
                                const target = $(_clicked.attr('data-target'));
                                target.removeClass('open');
                            }
                        }

                        if (jQuery(_clicked).is('a')) {
                            const _target = $(this).attr('target');
                            setTimeout(function () {
                                if (typeof _target !== 'undefined' && _target !== false) {
                                    window.open(_clicked.attr('href'), "_blank")
                                } else {
                                    window.location.href = _clicked.attr('href');
                                }
                            }, 700);
                        }
                    });


                    function createMenu(id, style_class, items) {
                        if (style_class == 'style2') {
                            items.attr('id', id);
                            items.addClass('style2');
                            body.append(items);
                        } else {
                            const menu = $(`<ul class="mini-mobile-sub list ${style_class}" id="${id}"></ul>`);
                            const menuButton = $(`[data-target='#${id}']`);

                            // menu.css({
                            //     'left': menuButton.offset().left + (menuButton.innerWidth() / 2) - 25,
                            // });

                            items.each(function (index, item) {
                                const _item = $(item).addClass('item');
                                menu.append($(`<li></li>`).append(_item));
                            })
                            body.append(menu);
                        }
                    }

                    $(document).click(function (event) {
                        var $target = $(event.target);

                        if (!$target.hasClass('mini-mobile-item') && !$target.closest('.menu-list').length) {
                            $('.mini-mobile-item.open').removeClass('open');
                            $('.mini-mobile-sub.open').removeClass('open');
                            $('.menu-list.open').removeClass('open');
                            $('.burger.open').removeClass('open');
                        }
                    });
                }
            }
        );
    }
)(jQuery);
